import React, {useState, useEffect, useContext, useRef} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonDatetime, IonFooter, IonTextarea, useIonRouter } from '@ionic/react';
import { IonSlides, IonSlide, IonLabel } from '@ionic/react';

//import { EnterPasswordModal } from './Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import {PayModal_JobBoard} from './Modal_Pay_JobBoard';


import '../../css/layout.css'

export function CreateRequisitionModal_Public (props) {

    //alert('inside CreateEmployeeModal');
    //alert(props.openModal);

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [authenticated, setIsAuthenticated] = useState(authenticatedMerchent_context.authenticated);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [showPasswordModal, setShowPasswordModal] = useState(false);
    //let [enteredPassword, setEnteredPassword] = useState('');
    let [selectedFile, setSelectedFile] = useState(null);

    let [merchantLoginModal, setMerchantLoginModal] = useState(false);
    let [registerModal_merchant, setRegisterModal_merchant] = useState(false);


    let [merchantFirstName, setMerchantFirstName] = useState('');
    let [merchantLastName, setMerchantLastName] = useState('');
    let [mobileNumber, setMobileNumber] = useState('');
    let [merchantCompanyName, setMerchantCompanyName] = useState('');
    let [merchantCity, setMerchantCity] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    let [merchantBusinessType, setBusinessType] = useState('T4');
    let [paymentType, setPaymentType] = useState('');
    let [amount, setAmount] = useState('');

    let [username, setUsername] = useState('');
    let [password, setPassword] = useState('');

    let [disablePayButton, setDisablePayButton] = useState(false);
    let [isloading, setLoading] = useState(false);
    let [openPayModal, setOpenPayModal] = useState(false);

    let [saveEvent, setSaveEvent] = useState([]);
    
    let employeeCompanyRoleRef = useRef('individual_contributor');
    let requisitionNameRef = useRef();
    let requisitionResponsibilitiesRef = useRef();
    let requisitionQualificationsRef = useRef();
    let applicationDeadlineRef = useRef();

    let selectedFileRef = useRef();
    let router = useIonRouter();


    function activateRequisition(event, authenticatedAccount, accountID)
    {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74500_createRequisition_activate',
                user: accountID,
                xEmployeeCompanyRole: event[0],
                xRequisitionName: event[1],
                xRequisitionResponsibilities: event[2],
                xRequisitionQualifications: event[3],
                xRequisitionDeadlineDate: event[4],
                xEnterAdminPassword: event[5],
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function saveUploadedFile(event) {
    
        //alert(event);
        
        if(event.target.files === null)
        {
            selectedFileRef.current.value = "/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg";
            //setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg")

        }
        else
        {
            selectedFileRef.current.value = event.target.files[0];
            //setSelectedFile(event.target.files[0]);
        }


    }


    function handlePostJob(event)
    {

            setSaveEvent(event);
            setOpenPayModal(true);

    }

    function handleMobileNumberChange(e) {

        const IonInput = e.detail.value || '';
        if (!IonInput.startsWith('0')) {
            setErrorMessage('Mobile number must start with 0.');
        } else {
            setErrorMessage('');
        }
        setMobileNumber(IonInput);
    };


    function closeModalHandler() {

        alert('JOB POSTED SUCCESSFULLY.');
        //router.push('/jobBoard_merchantMainPageApp', 'forward', 'replace');
        window.location.href = '/jobBoard_merchantMainPageApp';

        props.closeModal(false);
    }

    useEffect(() => {
    
        //alert(props.data.status);
    
    
        if(acctID == null)
        {
            setPaymentType('cash');
            setAmount('0.00');
        }
        else
        {
            setPaymentType('mm');
            setAmount('50.00');
        }

    }, [])

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader style={{color: "black"}}>
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <IonText className='professional-input'>CREATE REQUISITION</IonText>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>
        <IonContent className='grid_content_details'>
                <IonGrid>
                    <IonRow>
                        <IonCol size='6'>
                            <label for='searchSupplierName'>First Name:</label>
                        </IonCol>
                        <IonCol size='6'>
                            <label for='searchSupplierName'>Last Name:</label>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <IonInput className='professional-input' type='text' value={merchantFirstName} placeholder='Enter First Name' autocomplete='off' onIonChange={(e) => setMerchantFirstName(e.target.value)} required></IonInput>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput className='professional-input' type='text' value={merchantLastName} placeholder='Enter Last Name' autocomplete='off' onIonChange={(e) => setMerchantLastName(e.target.value)} required></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size="6">
                            <label htmlFor="searchSupplierName">MTN Momo #:</label>
                        </IonCol>
                        <IonCol size="6">
                            <IonInput
                                className='professional-input'
                                id="searchSupplierName"
                                placeholder="Enter mobile number"
                                type="tel"
                                value={mobileNumber}
                                onIonChange={(e) => handleMobileNumberChange(e)}
                                required/>
                            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <label for='searchSupplierName'>  Company Name:</label>
                        </IonCol>
                        <IonCol size='6'>
                            <label for='searchSupplierName'>  City</label>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <IonInput className='professional-input' type='text' value={ merchantCompanyName }  placeholder='Enter Company Name - 22 Letter Max' autocomplete='off' maxLength={22} onIonChange={(e) => setMerchantCompanyName(e.target.value)}  required></IonInput>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput className='professional-input' type='text' value={ merchantCity }  placeholder='Enter City' autocomplete='off' maxLength={22} onIonChange={(e) => setMerchantCity(e.target.value)}  required></IonInput>
                        </IonCol>
                    </IonRow>
                    {/* <IonRow>
                        <IonCol size='12'>
                            <label for='searchSupplierName'>  Business Type:</label>
                        </IonCol>
                    </IonRow>
                   <IonRow>
                        <IonCol size='12'>
                            <select name="businesstype" id='businesstype'>
                                <option value='T4' selected='selected'>Job Board</option>
                            </select>
                        </IonCol>
                    </IonRow>
                <IonRow>
                    <IonLabel for="employeeRole">Requisition Role </IonLabel>
                </IonRow>
                    <IonCol >
                        <select name="employeeRole" id='employeeRole' ref={employeeCompanyRoleRef }>
                            <option value='individual_contributor'>Individual Contributor</option>
                            <option value='front_desk'>Front Desk</option>
                            <option value='cleaning_service'>Cleaning Services</option>
                            <option value='manager'>Manager</option>
                        </select>
                    </IonCol>*/}
                <IonRow>
                    <IonCol>
                        <IonLabel>Position Name: </IonLabel>
                        <IonInput className='professional-input' placeholder='Enter Name' ref={ requisitionNameRef }></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                            <IonLabel>Application Deadline </IonLabel>

                            {authenticatedMerchent_context.device == 'mobile' && <IonDatetime className='professional-input' displayFormat='MMM DD, YYYY' placeholder='Select Deadline' ref={applicationDeadlineRef}>  </IonDatetime> }         {/*text={startDateRange.toLocaleString('en-us', {month: 'long', day: '2-digit'}) +', '+startDateRange.getFullYear()} */}
                            {authenticatedMerchent_context.device == 'desktop' &&  <IonInput className='professional-input' type='date' placeholder='Select Deadline' ref={applicationDeadlineRef}> </IonInput>  }
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonLabel>Responsibilities: </IonLabel>
                        <IonTextarea className='professional-input' cols="50" rows="10" placeholder='Enter Position Responsibilites' ref={ requisitionResponsibilitiesRef }></IonTextarea>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonLabel>Qualifications: </IonLabel>
                        <IonTextarea className='professional-input' cols="50" rows="10" placeholder='Enter Position Qualifications' ref={ requisitionQualificationsRef }></IonTextarea>
                    </IonCol>
                </IonRow>
            </IonGrid>

       {/* <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>*/}
        </IonContent>

        <IonFooter className='grid_footer'>
            <IonGrid>
                <IonRow>
                    <IonCol>
                        <IonButton onClick={() => handlePostJob([employeeCompanyRoleRef.current.value, requisitionNameRef.current.value, requisitionResponsibilitiesRef.current.value, requisitionQualificationsRef.current.value, applicationDeadlineRef.current.value])}>Submit</IonButton>
                    </IonCol>
                    <IonCol>
                        <IonButton onClick={() => props.closeModal(false)}>Cancel </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonFooter>


        {openPayModal == true && <PayModal_JobBoard openModal={ openPayModal } closeModal={() => closeModalHandler()} payCloseModal={(event) => setOpenPayModal(event)} data={{
                status: 'create_order_internal',
                companyId: '1',
                companyPhoneNumber: mobileNumber,
                mtnCompanyPhoneNumber: mobileNumber,
                cartList:[{ id: "00",
                            name: "JOB POST - "+merchantCompanyName+ " - "+ requisitionNameRef.current.value,
                            price: amount,
                            quantity: 1}],
                firstName: merchantFirstName, 
                lastName: merchantLastName,
                merchantCompanyName: merchantCompanyName,
                merchantCity: merchantCity,
                merchantBusinessType: merchantBusinessType,
                mobileNumber: mobileNumber,
                payeeMessage: 'Job Post Payment',
                cartSubtotal: amount,
                cartCheckoutTotal: amount,
                paymentType: paymentType,
                payment_amount: amount,
                //cartLatitude: cartLatitude,
                //cartLongitude: cartLongitude,
                //storefront: storefront,
                requisitionEvent: saveEvent,
                }}></PayModal_JobBoard>}

        </IonModal>) : null}
    </React.Fragment>
    )
}